/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import connect from '../utils/connect';

import { Flex } from '@app/ui';

import ErrorBoundary from '../ErrorBoundary';
import CrashedComponent from '../components/errors/CrashedComponent';
import InVenueProvider from './InVenue.context';
import Filters from './InVenueFilters';

import GenderBreakdownSection from './sections/GenderBreakdown';
import AgeBreakdownSection from './sections/AgeBreakdown';
import CrowdFlow from './sections/CrowdFlow';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const crowdIQ = require('../images/crowdIQ.png');

const InVenue = () => {
    return (
        <InVenueProvider>
            <Flex vertical className="gds-layout__container invenue-container">
                <div className="gds-flex invenue-container-header">
                    <h2 className="gds-text--header-md -m-b-3 -m-t-3">
                        In-Venue
                    </h2>
                    <div className="powered-by-crowd-iq-container">
                        <p>Powered by</p>
                        <img src={crowdIQ} className="crowd-iq-logo" />
                    </div>
                </div>

                <ErrorBoundary FallbackComponent={CrashedComponent}>
                    <Filters isDefaultOpen />
                </ErrorBoundary>

                <GenderBreakdownSection />
                <AgeBreakdownSection />
                <CrowdFlow />
            </Flex>
        </InVenueProvider>
    );
};

export default connect(['client'])(InVenue);
